<template>
    <div class="no__page">
        <img class="no__page__bg zIndex-1" src="../../static/dci-404-bg.jpg" alt="未找到" />
        <div class="no__page__mask zIndex-1"></div>
        <div class="no__page__content">
            <div class="line left__line"></div>
            <div class="no__page__content__circle">
                <p>404</p>
                <p>当前访问页面不存在或页面地址已修改</p>
                <p>点击按钮跳转首页</p>
                <div @click="goBackHome">返回首页</div>
            </div>
            <div class="line right__line"></div>
        </div>
        <p class="no__page__foot zIndex-10">the page you were looking for doesn't exist</p>
        <p class="no__page__foot zIndex-10">you may have mistyped the address or the page may have moved </p>
    </div>
</template>
<script>
export default {
    components: {
         
    },
    data() {
        return {
             
        };
    },
    computed: {
    
    },
    watch: {
    
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        goBackHome(){
            this.$router.push({
                path: '/'
            })
        }
    },
}
</script>
<style lang='scss' scoped>
@import'./index.scss';
</style>